import styled from '@emotion/styled';
import { Divider, Grid, Paper, Typography } from '@material-ui/core';
import { createElement, FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { MuiGridSizes } from '../../../../utilityTypes/MaterialUITypes';
import { SPACING_REGULAR, SPACING_UNIT } from '../../../constant/spacing';

interface Props {
  children: ReactNode;
  titleMessageId: string;
  gridItemXs?: MuiGridSizes;
  gridItemLg?: MuiGridSizes;
}

const FormatDetailBlock: FC<Props> = ({ children, titleMessageId, gridItemXs = 12, gridItemLg = 7 }) => {
  return (
    <Grid item xs={gridItemXs} lg={gridItemLg}>
      <FormatDetail>
        <ItemName variant="subtitle1">
          <FormattedMessage id={titleMessageId} />
        </ItemName>
        <Divider />
        {children}
      </FormatDetail>
    </Grid>
  );
};

const ItemName = styled(Typography)({
  marginBottom: SPACING_UNIT,
});

const FormatDetail = styled(Paper)({
  padding: SPACING_REGULAR,
});

export default FormatDetailBlock;
